import React, {useContext} from 'react';
import {sendWapp} from "./Utils/sendWapp";
import ClienteDirectoContext from "../context/ClienteDirectoContext";
import {ReactComponent as WhatsappIcon} from "../assets/systemIcons/whatsapp.svg";

function WhatsAppFab() {
    const {datosPolkista} = useContext(ClienteDirectoContext);
    return (
        <div className="FAB"
             onClick={
                 () => sendWapp(`https://wa.me/${datosPolkista['Telefono']}?text=¡Buenos%20días!%20Necesito%20ayuda%20con%20la%20compra%20de%20un%20seguro%20desde%20su%20plataforma%20digital...`)
             }
        >
            <WhatsappIcon className="FAB__image" />
        </div>
    );
}

export default WhatsAppFab;